<template>
  <div :class="`main-header ${headerClass}`">
    <div class="container">
      <Header />
    </div>
  </div>
  <div :class="`relative ${headerClass}`">
    <div
      class="relative"
      :class="`banner-background ${bannerHeight}`"
      :style="`background-image: url(&quot;${event.posterUrlLandscape}&quot;);`"
    >
      <div class="card-top-overlay"></div>
      <div class="card-bottom-overlay light"></div>
      <div :class="`flex items-end ${textHeight}`">
        <div class="container z-10 relative">
          <div class="absolute bottom-[-10pc] w-full">
            <template v-if="fetchingEvent">
              <div role="status" class="animate-pulse">
                <div
                  class="h-5 bg-gray-200 dark:bg-gray-700 w-1/5 mb-4 rounded-xl"
                ></div>
                <div
                  class="h-16 bg-gray-200 dark:bg-gray-700 w-2/5 mb-4 rounded-xl"
                ></div>

                <div
                  class="h-5 bg-gray-200 dark:bg-gray-700 w-1/6 mb-4 rounded-xl"
                ></div>
              </div>
            </template>
            <template v-else>
              <div class="main-subtitle">
                {{ event.subtitle }}
                <n-3-badge
                  :label="event.tagOffer"
                  class="ml-5"
                  v-if="event.tagOffer"
                />
              </div>
              <div class="main-title">
                {{ event.title }}
              </div>
              <div class="grid grid-cols-5 grid-flow-col gap-[6rem]">
                <div class="col-span-3">
                  <div class="text-subtitle">
                    <div class="mt-1">
                      {{ dateTimeFormat(event.date, "ddd Do MMM YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="relative">
    <div class="before-transparent"></div>
  </div>
  <router-view />
  <Footer :class="headerClass" />
</template>
<script>
import Header from "@/components/Header.vue";
import { computed, onMounted, reactive, toRefs } from "@vue/runtime-core";
import { getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { dateTimeFormat, scrollToTop } from "@/utils/helper";
import Footer from "@/components/Footer.vue";
import N3Badge from "@/components/show/N3Badge.vue";
export default {
  components: { Header, Footer, N3Badge },
  setup() {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const state = reactive({
      section: computed(() => proxy.$route.name || ""),
      event: computed(() => store.state.event.event),
      showHeader: computed(() => store.state.event.showHeader),
      fetchingEvent: computed(() => store.state.event.fetchingData),
      headerClass: computed(() => {
        return state.showHeader ? "" : "hidden sm:block";
      }),
      bannerHeight: computed(() => {
        let height = "n3-banner-min-height";
        if (state.section === "event") {
          height = "n3-banner-full-height";
        }

        return height;
      }),

      textHeight: computed(() => {
        let height = "n3-content-min-height";
        if (state.section === "event") {
          height = "n3-content-full-height";
        }

        return height;
      }),
    });

    onMounted(async () => {
      scrollToTop();
    });

    return {
      ...toRefs(state),
      dateTimeFormat,
    };
  },
};
</script>
<style lang="scss">
.expanded-bg {
  height: 100%;
  position: absolute;
  width: -webkit-fill-available;
  background-color: #000;
}
.before-transparent {
  content: "";
  width: 100%;
  height: 150px;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  ); /* FF3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(0, 0, 0, 0)),
    color-stop(100%, rgba(0, 0, 0, 0.7))
  ); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  ); /* Opera 11.10+ */
  background: -ms-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  ); /* IE10+ */
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.7) 100%
  ); /* W3C */

  z-index: 16;
  top: -150px;
}
</style>
